import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import i18n from '../libs/i18n';
import { changeFilter } from '../actions/productsDirectory';

import ProductsDirectorySubCategory from './ProductsDirectorySubCategory.jsx';
import { Layout, LayoutItem } from './Layout';

function mapStateToProps(state) {
  const { productsDirectory } = state;
  const { categories, currentFilter } = productsDirectory;

  const selectedCategories = (currentFilter) ?
    categories.filter((cat) => cat.id === currentFilter) : categories;
  const currentFilterTitle = (selectedCategories.length > 1) ?
    i18n.translate('allProducts.catGen') : i18n.translate(selectedCategories[0].name);

  let subcategories = [];
  const filters = categories.map((cat) => cat.id);

  for (let i = 0; i < selectedCategories.length; i++) {
    const cat = selectedCategories[i];
    const newSubCategories = cat.subcategories.map((sc) =>
      Object.assign({}, sc, { category: cat.id }));

    subcategories = [...subcategories, ...newSubCategories];
  }

  return { filters, currentFilter, currentFilterTitle, subcategories };
}
function mapDispatchToProps(dispatch) {
  return {
    onFilterChange: (filter) => {
      dispatch(changeFilter({ filter }));
    },
  };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class ProductsDirectory extends React.Component {
  static propTypes = {
    filters: PropTypes.array,
    currentFilter: PropTypes.string,
    currentFilterTitle: PropTypes.string,
    subcategories: PropTypes.array,
    onFilterChange: PropTypes.func,
  };

  render() {
    const {
      filters,
      currentFilter,
      currentFilterTitle,
      subcategories,
      onFilterChange,
    } = this.props;

    const styles = {
      wrapper: classnames({
        'products-directory': true,
      }),
      filterList: classnames({
        'products-directory--filter-list': true,
      }),
    };

    // fix for last items to keep sizes
    const ghostSubcategories = (subcategories.length >= 2) ?
      [...Array(3 - (subcategories.length % 3))] : [];
    const ghostFilters = (filters.length >= 3) ?
      [...Array(3 - (filters.length % 3))] : [];

    return (
      <div className={styles.wrapper}>
        <Layout direction="column" fallbackToRowAt="medium-screens">
          <LayoutItem>
            <ul className={styles.filterList}>
              {filters.map((f) => {
                const filterClasses = {
                  'products-directory--filter-list--cat': true,
                  [`products-directory--filter-list--cat-${f}`]: true,
                  active: currentFilter === f,
                };

                const filterStyle = classnames(filterClasses);
                const toggleThatFilter = () => {
                  onFilterChange((currentFilter !== f) ? f : null);
                };

                return (
                  <li key={`filter-${f}`} className={filterStyle} onClick={toggleThatFilter} />
                );
              })}
              {ghostFilters.map((f) => (
                <li
                  key={`ghost-filter-${f}`}
                  className="products-directory--filter-list--ghost-cat"
                />
              ))}
            </ul>
          </LayoutItem>
          <LayoutItem grow>
            <div className="products-directory--filter-title">{currentFilterTitle}</div>
            <ReactCSSTransitionGroup
              component="ul"
              className="products-directory--subcat-grid"
              transitionName="products-directory--subcat-grid--subcat"
              transitionEnterTimeout={750}
              transitionLeaveTimeout={250}
            >
              {subcategories.map((s) => (
                <ProductsDirectorySubCategory
                  key={s.id}
                  name={i18n.translate(s.name)}
                  link={s.link}
                  color={s.category}
                />
              ))}
              {ghostSubcategories.map((u, i) => (
                <ProductsDirectorySubCategory
                  key={`ghost-subcategory-${i}`}
                  ghost
                />
              ))}
            </ReactCSSTransitionGroup>
          </LayoutItem>
        </Layout>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/ProductsDirectory.jsx
 **/